// @ts-nocheck
import t from '@/store/types';
import { IFundsState } from './funds.type';

const initialState: IFundsState = {
  fundsTableState: {},
  selectedFund: null,
};

export default function fundsReducer(state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case t.FUNDS_TABLE_STATE_SET:
      return {
        ...state,
        fundsTableState: {
          ...state.fundsTableState,
          ...payload.queries,
        },
      };

    case t.FUNDS_TABLE_STATE_RESET:
      return {
        ...state,
        fundsTableState: initialState.fundsTableState,
      };

    default:
      return state;
  }
} 